const ORDERS = {
  ROLE_SELLER: 'seller',
  ROLE_BUYER: 'buyer',
  STATUS_OPEN: 'open',
  STATUS_DONE: 'done',
  STATUS_CANCEL: 'cancel',
  STATUS_CREATE_INT: 0,
  STATUS_CONFIRMED_INT: 10,
  STATUS_COMPLETED_INT: 20,
  STATUS_DISPUTE_INT: 40,
  STATUS_CANCELED_INT: 50,
};

export default ORDERS;
